import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

import Footer from "../components/Footer";
import CardCarousel from "../components/CardCarousel";

const Home = () => {

  const [projectDisplay, setProjectDisplay] = useState(<></>);
  const [serviceDisplay, setServiceDisplay] = useState(<></>);

  useEffect(() => {(async () => {
      try {
        const res = await fetch("https://oncadevelopment.com/api/overview");
        if (!res.ok) throw new Error("Failed to fetch projects");
        const data = await res.json();
        console.log(data)

        setServiceDisplay(
          <CardCarousel speed={30}>
            {
              data.services.map((item, idx) => <div className="card" key={idx}>
                <p className="subtitle">{ item.category_name }</p>
                <h3>{ item.service_name }</h3>
                <p>{ item.service_description }</p>
              </div>)
            }
          </CardCarousel>
        )

        setProjectDisplay(
          <CardCarousel speed={40}>
            { 
              data.projects.map((item, idx) => <div className="card" key={ idx }>
                <p className="subtitle">{ item.location }</p>
                <Link to="portfolio/"><h3>{ item.name }</h3></Link>
              </div>) 
            }
          </CardCarousel>
        )

      } catch (err) {
        
      }
  })()}, [])

  return <>
    <main>
      <h1>ONCA Development is a property development and management agency, based in New York.</h1>
      <p>We pair global talent with local expertise to provide smart solutions for your real property, from start to finish.</p>
      <section>
        <Link to="services"><h2>Services {'>'}</h2></Link>
        { serviceDisplay }
      </section>
      <section>
        <Link to="portfolio"><h2>Portfolio {'>'}</h2></Link>
        { projectDisplay }
      </section>
    </main>
    <footer>
      <Link to="/contact">
        <button>Have a project? Let's talk 👉</button>
      </Link>
    </footer>
  </>
}

export default Home;